var _excluded = ["href", "title", "className", "children", "onClick", "rel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import config from 'react-global-configuration';
import urlParse from 'url';
var CoreLink = function CoreLink(props) {
  var href;
  var hrefProp = props.href,
    title = props.title,
    className = props.className,
    children = props.children,
    onClick = props.onClick,
    _props$rel = props.rel,
    rel = _props$rel === void 0 ? 'noopener noreferrer' : _props$rel,
    restProps = _objectWithoutProperties(props, _excluded);

  // Prefer the href prop, but allow the deprecated to prop as fallback.
  if (hrefProp !== undefined) {
    href = hrefProp;
  } else {
    var to = props.to;
    href = to;
  }
  var host = window.location.hostname;
  var API_URL = config.get('API_URL');
  var isInternal = function (url) {
    if (/^internal:/.test(url)) {
      href = href.replace(/^internal:/, '');
      return true;
    }
    return false;
  }(href);
  var isEntity = function (url) {
    if (/^entity:/.test(url)) {
      href = href.replace(/^entity:/, '');
      return true;
    }
    return false;
  }(href);
  var isFile = function (url, _url$split$pop) {
    if (!url) return false;
    return Number((_url$split$pop = url.split('/').pop()) === null || _url$split$pop === void 0 ? void 0 : _url$split$pop.indexOf('.')) > -1;
  }(href);
  var isMailto = function isMailto(url) {
    return /^mailto:/.test(url);
  };
  var isPhoneLink = function isPhoneLink(url) {
    return /^tel:/.test(url);
  };

  /**
   * This if statement is purely for backwards compatibility.
   * Since we've moved this file to typescript you're required to use the href/to prop.
   * Though for older JS projects you might still have a CoreLink somewhere without an href.
   * That's why we've let this if statement in place.
   */
  if (!href) {
    if (children) {
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      return /*#__PURE__*/React.createElement("a", {
        className: className
      }, children);
    }
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    return /*#__PURE__*/React.createElement("a", {
      className: className
    }, title);
  }
  function getHostOrPathNameFromUrl(url) {
    var hostname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    // Parse the url using the url package. Using whatwg-url gives issues,
    // we consider this safe enough for our use-case.
    var parsed = urlParse.parse(url);
    if (hostname) {
      // If the given url contains a hostname, return it.
      if (parsed.hostname !== null) {
        return parsed.hostname;
      }

      // Otherwise, fall back to the current hostname. This happens for
      // internal links, such as /foobar.
      return window.location.hostname;
    }
    return (parsed.pathname || '') + (parsed.search || '') + (parsed.hash || '');
  }
  var linkHost = getHostOrPathNameFromUrl(href);
  var apiHost = getHostOrPathNameFromUrl(API_URL);
  var onClickFunction = function onClickFunction(e) {
    if (onClick) {
      onClick(e);
    }
  };

  // If mailto: or tel:, render a regular a tag and don't scroll the page.
  if (isPhoneLink(href) || isMailto(href)) {
    return /*#__PURE__*/React.createElement("a", _extends({}, restProps, {
      onClick: onClick,
      target: "_blank",
      rel: rel,
      className: className,
      href: href
    }), children || title);
  }
  if (isFile || (!isInternal || !isEntity) && host !== linkHost && apiHost !== linkHost) {
    // Link is external, or a link to a static file, so create a default anchor.
    return /*#__PURE__*/React.createElement("a", _extends({}, restProps, {
      onClick: onClickFunction,
      target: "_blank",
      rel: rel,
      className: className,
      href: href
    }), children || title);
  }

  // Link is internal, so use a Link to navigate with the History API.
  var pathnameTo = href;

  // Convert links to the same domain to a relative link.
  if (host === linkHost || apiHost === linkHost) {
    pathnameTo = getHostOrPathNameFromUrl(href, false);
  }
  return /*#__PURE__*/React.createElement(Link, _extends({}, restProps, {
    onClick: onClickFunction,
    className: className,
    to: pathnameTo
  }), children || title);
};
export default CoreLink;